// extracted by extract-css-chunks-webpack-plugin
module.exports = {"bank-logo":"_U3QYK","icon":"_3Yzgw2"};